import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import {
  Radio,
  Card,
  Button,
  Divider
} from '@lockerpm/design';

import {
  PlusOutlined
} from "@ant-design/icons";

import upgradeComponents from "../../../../../components/upgrade";
import itemsComponents from "../../../../../components/items";

import paymentServices from "../../../../../services/payment";

const CardSelect = (props) => {
  const { t } = useTranslation();
  const {
    CreditCard
  } = itemsComponents;
  const {
    UpgradePayment
  } = upgradeComponents;
  const {
    result = {},
    selectedCard = {},
    setSelectedCard = () => { },
  } = props;

  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isAddCard, setIsAddCard] = useState(false);

  useEffect(() => {
    fetchCards();
  }, [])

  const fetchCards = async () => {
    setLoading(true);
    await paymentServices.get_payments_cards().then((res) => {
      setCards(res);
      if (res.length) {
        setSelectedCard(res[0]);
      } else {
        setIsAddCard(true);
      }
    }).catch(() => {
      setIsAddCard(true);
    })
    setLoading(false);
  }

  const handleAddedCard = async (card) => {
    setIsAddCard(false);
    await fetchCards();
    setSelectedCard(card);
  }

  return (
      <Card
        title={
          <p className="text-[18px] font-semibold">
            {t('manage_plans.payment_step.step_2')}
          </p>
        }
        loading={loading}
      >
      {
        cards.length > 0 && <div>
          <Radio.Group
            value={selectedCard.id_card}
            onChange={(e) => setSelectedCard(cards.find((c) => c.id_card === e.target.value))}
          >
            {
              cards.map((card) => <Radio
                key={card.id_card}
                value={card.id_card}
                className="!flex mb-4 items-center"
              >
                <CreditCard
                  className="w-[200px]"
                  card={card}
                />
              </Radio>)
            }
          </Radio.Group>
        </div>
      }
      {
        cards.length > 0 && <div>
          <Divider />
          {
            !isAddCard && <Button
              className="mt-m"
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setIsAddCard(true)}
            >
              {t('billing.add_btn')}
            </Button>
          }
        </div>
      }
      {
        isAddCard && <UpgradePayment
          isCancel={cards.length > 0}
          result={result}
          onAdded={handleAddedCard}
          onCancel={() => setIsAddCard(false)}
        />
      }
    </Card>
  );
}

export default CardSelect;